var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M12.3478 4.83334L4 24.1667H12.3478L20 4.83334H12.3478Z","stroke":"currentColor","stroke-opacity":"0.99","stroke-width":"1.5","stroke-linejoin":"round","fill":"none"}})
}
var staticRenderFns = []

export { render, staticRenderFns }